import { InputLabel as InputLabelMui, InputLabelProps as InputLabelPropsMui } from '@mui/material';

export type InputLabelProps = InputLabelPropsMui;

export const InputLabel = InputLabelMui;
